/** Nothing is carried over from the URL unless a consumer opts in. */
export const NO_PRESERVED_PARAMETERS: readonly string[] = [];
